import {
  REQUEST_CALCULATION_METHODS, RECEIVE_CALCULATION_METHODS, RECEIVE_CALCULATION_METHOD,
} from '../actions/calculation-methods';

const reducer = (state = {
  items: [],
  loading: false,
  item: {},
}, action) => {
  switch (action.type) {
    case REQUEST_CALCULATION_METHODS:
      return { ...state, loading: true };
    case RECEIVE_CALCULATION_METHODS:
      return { ...state, items: action.json.data, loading: false };
    case RECEIVE_CALCULATION_METHOD:
      return {
        ...state,
        item: action.json,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
